import React, { useState } from "react";
import { Paper, Grid, TextField, Button } from "@material-ui/core";
import { Face, Fingerprint } from "@material-ui/icons";
import { useDispatch } from "react-redux";
import sktrDetailsSlice from "../redux/sktrSlice";
import axios from "axios";
const LoginTab = (props) => {
  const [values, setValues] = useState({
    username: "",
    password: "",
    validCreds: true,
  });
  const dispatch = useDispatch();
  const loginHandler = (e) => {
    e.preventDefault();
    console.log("loginHandler");
    let username = values.username,
      password = values.password;

    if (username === "test@admin.com" && password === "1234321") {
      var config = {
        method: "get",
        url: "https://identity-stage.spireon.com/identity/token",
        headers: {
          "X-Nspire-AppToken": " 56f7aba5-4c1a-11ec-8cc3-0242ac120008",
          "X-Nspire-Account": " 1643061913551NQDXVQ1",
          Authorization:
            "Basic ZHZpZG15Y2h0ZXN0MkBzcGlyZW9uLmNvbTp0ZXN0ZHZ0ZXN0",
        },
      };
      let token;
      axios(config)
        .then(function (response) {
          token = response.data.token;
          // Set authToken to Local Storage
          const now = new Date();
          const item = {
            token: token,
            expiry: now.getTime() + 60 * 100000,
          };
          localStorage.setItem("authToken", JSON.stringify(item));
          setValues((prevState) => {
            return {
              username: prevState.username,
              password: prevState.password,
              validCreds: true,
            };
          });
          dispatch(sktrDetailsSlice.actions.login());
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      setValues((prevState) => {
        return {
          username: prevState.username,
          password: prevState.password,
          validCreds: false,
        };
      });
    }
  };
  return (
    <div
      style={{ width: "600px", left: "25%", top: "25%", position: "absolute" }}
    >
      <Paper>
        <div style={{ padding: "50px" }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Face />
            </Grid>
            <Grid item md={true} sm={true} xs={true}>
              <TextField
                id="username"
                label="Username"
                type="email"
                fullWidth
                autoFocus
                required
                defaultValue={values.username}
                onChange={(event) => {
                  const { value } = event.target;
                  setValues((prevState) => {
                    return {
                      username: value,
                      password: prevState.password,
                      validCreds: prevState.validCreds,
                    };
                  });
                }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Fingerprint />
            </Grid>
            <Grid item md={true} sm={true} xs={true}>
              <TextField
                id="password"
                label="Password"
                type="password"
                fullWidth
                required
                defaultValue={values.password}
                onChange={(event) => {
                  const { value } = event.target;
                  setValues((prevState) => {
                    return {
                      username: prevState.username,
                      password: value,
                      validCreds: prevState.validCreds,
                    };
                  });
                }}
              />
            </Grid>
          </Grid>
          <Grid container justifyContent="center" style={{ marginTop: "40px" }}>
            <Button
              variant="outlined"
              color="primary"
              style={{ textTransform: "none" }}
              onClick={loginHandler}
            >
              Login
            </Button>
          </Grid>
        </div>
        {!values.validCreds ? (
          <div style={{ color: "red" }}>
            Invalid credentials !! Please check username and password.
          </div>
        ) : (
          ""
        )}
      </Paper>
    </div>
  );
};

export default LoginTab;
